import { useEffect, useRef, useCallback } from 'react';

export const useHorizontalDragScroll = (deps: any[] = []) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartScrollRef = useRef(0);

  const onMouseDown = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    const container = ref.current;
    if (!container) return;
    isDraggingRef.current = true;
    dragStartXRef.current = event.clientX;
    dragStartScrollRef.current = container.scrollLeft;
  }, []);

  const onMouseMove = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    const container = ref.current;
    if (!container || !isDraggingRef.current) return;
    const deltaX = event.clientX - dragStartXRef.current;
    container.scrollLeft = dragStartScrollRef.current - deltaX;
  }, []);

  const onMouseUp = useCallback(() => {
    isDraggingRef.current = false;
  }, []);

  const onMouseLeave = useCallback(() => {
    isDraggingRef.current = false;
  }, []);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const handleWheel = (event: WheelEvent) => {
      const delta = event.deltaY !== 0 ? event.deltaY : event.deltaX;
      if (delta === 0) return;
      container.scrollLeft += delta;
      event.preventDefault();
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, deps);

  return {
    ref,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
  };
};
